module.exports = __webpack_public_path__ + "static/media/wifi.f8aaa6c7.svg";